/** Only a rejected cookie means the session is over; an outage or timeout does not. */
export function sessionRejected(error: unknown): boolean {
  const status = (error as { status?: number } | null)?.status;
  return status === 401 || status === 403;
}
